import { render, staticRenderFns } from "./ChallengeTopicMessageForm.vue?vue&type=template&id=21a0728e"
import script from "./ChallengeTopicMessageForm.vue?vue&type=script&lang=ts"
export * from "./ChallengeTopicMessageForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports